import { Injectable } from '@angular/core';

import { RestService } from "../../../../core/services/rest.service";
import { TipoObrigacao } from "./obrigacao-tipo.model";
import { apiName } from "./data.service";

@Injectable()
export class ObrigacaoTipoApiService {

  constructor(
    private _restService: RestService,
  ) { }

  onPost(object: TipoObrigacao, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: TipoObrigacao, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":["titulo"]};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-tipos/shared/obrigacao-tipo-api.service.ts
 **/